<div class="ebo-alert" [ngClass]="'ebo-alert--' + type">
  <div class="ebo-alert-content">
    <p class="ebo-alert-title">{{ title }}</p>
    <p *ngIf="description" class="ebo-alert-description">{{ description }}</p>
    <div class="ebo-alert-actions" *ngIf="hasActions">
      <ng-content></ng-content>
    </div>
  </div>
  <button type="button" class="ebo-alert-close" (click)="close()" aria-label="Close alert">
    <mat-icon>close</mat-icon>
  </button>
</div>
